<div class="bg-light px-3">
  <app-harbour-dues-header
    [declarationTabs]="declarationTabs"
    [declarationSelected]="declarationSelected()"
    [selectedDeclaration]="selectedDeclaration()"
    [saveAndSendDisabled]="saveAndSendDisabled()"
    [hasCurrentVersionInvoice]="hasCurrentVersionInvoice()"
    (tabSelected)="selectDeclaration($event)"
    (saveDraft)="saveDraft()"
    (saveAndSend)="declare()"
    (declarationRejected)="rejectDeclaration()"
    (declarationAccepted)="acceptDeclaration()"
 />
  <app-tab-panel>
    <app-tab-item [templateRef]="details">
      <span class="tab-item">Details</span>
      <ng-template #details>
        <app-harbour-dues-rotterdam-details-tab
          [form]="form"
          [showValidationErrors]="showValidationErrors"
          [isAdmin]="isAdmin"
          [isHarbourDuesAdvisor]="isHarbourDuesAdvisor || isAdmin"
          [declarationTabs]="declarationTabs"
          [selectedDeclaration]="selectedDeclaration()"
          [visit]="savedVisit"
          [declarationSelected]="declarationSelected()"
          [hasBerthVisits]="declarationHasBerthVisits() || false"
          [vesselDeadWeightKg]="vesselDeadWeightKg"
          (validProFormaDisplayedChange)="validProFormaDisplayed.set($event || false);"
          (proFormaRequested)="validate()"
        />
      </ng-template>
    </app-tab-item>
  <app-tab-item [templateRef]="history">
      <span class="tab-item">History</span>
      <ng-template #history>
        <app-harbour-dues-history-tab
          [declaration]="selectedDeclaration()">
        </app-harbour-dues-history-tab>
      </ng-template>
    </app-tab-item>
  </app-tab-panel>
</div>
